import { useUnit } from 'effector-react'

import { $activeChatDetails, $fanId } from '@/models/chattingUI/chats/chats.ts'
import { classNames } from '@/utils/helpers'

import { useToggleFollow } from '../../hooks/use-toggle-follow'

export const UnsubscribedMessage = () => {
  const activeChat = useUnit($activeChatDetails)
  const fanId = useUnit($fanId)
  const { followMutation } = useToggleFollow()

  const canFollow = activeChat?.withUser.subscribePrice === 0

  const handleClickFollow = () => {
    if (fanId) {
      followMutation.mutate(fanId)
    }
  }

  const followButton = (
    <button
      className={classNames(
        'text-primary-500',
        followMutation.isLoading && 'opacity-50',
      )}
      onClick={handleClickFollow}
      disabled={followMutation.isLoading}
    >
      follow
    </button>
  )

  return (
    <span>
      Please {canFollow ? followButton : 'subscribe'} to resume messaging
    </span>
  )
}
